module.exports = __webpack_public_path__ + "img/p5_title.4ccf1ccb.png";